<template>
    <tr class="report__list_table_item">
        <td class="report__list_table_name">{{reportName}}</td>
        <td class="report__list_table_area">{{reportArea}}</td>
        <td class="report__list_table_description">
            <component-text
                :read-more-active="true"
                :read-more-limit="100"
            >{{reportDescription}}
            </component-text>
        </td>
        <td class="report__list_table_actions">
            <div class="columns is-vcentered">
                <div class="column"></div>
                <template v-if="reportSchedule">
                    <div class="column is-narrow">
                        <component-button
                            :name="'report-list-table-item-collapse'"
                            :icon="true"
                            :icon-name="collapseActive ? 'chevron-up' : 'chevron-down'"
                            :theme="'default'"
                            @click="performEmit('emit-collapse', index)"
                        />
                    </div>
                </template>
                <div class="column is-narrow">
                    <component-button
                        :theme="'primary'"
                        :name="`report-list-table-item-actions-launch-${reportId}`"
                        @click="redirectToReportExecute"
                    >Run now
                    </component-button>
                </div>
                <div class="column is-narrow">
                    <template v-if="csvRequestPending">
                        <component-loading :size="'small'"></component-loading>
                    </template>
                    <template v-else>
                        <component-button-menu
                            :buttons="buttonMenuList"
                            @emit-edit="redirectToEdit"
                            @emit-schedule="redirectToSchedule"
                            @emit-delete="performRemoveReport"
                            @emit-export-to-csv="performGenerateCSV"
                        ></component-button-menu>
                    </template>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import ComponentText from '@/components/default/shared/ComponentText'
import { User } from '@/User'
import { toCapitalize } from '@/functions'
import ComponentLoading from '@/components/default/shared/ComponentLoading'

export default {
  components: { ComponentLoading, ComponentText, ComponentButtonMenu, ComponentButton },
  name: 'report-list-table-item',
  data () {
    return {
      user: new User(),
      csvRequestPending: false
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: [Number, String]
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    reportId () {
      return this.item.id
    },
    reportName () {
      return this.item.name
    },
    reportArea () {
      return toCapitalize(this.item.report)
    },
    reportDescription () {
      return this.item.description
    },
    reportSchedule () {
      return this.item.schedule
    },
    buttonMenuList () {
      const listArr = []

      if (this.user.isSuperadmin() || this.user.isMasterAdministrator()) {
        listArr.push({
          key: 'edit',
          name: 'Edit'
        })
      }
      listArr.push({
        key: 'schedule',
        name: 'Schedule'
      })
      listArr.push({
        key: 'export-to-csv',
        name: 'Export to CSV'
      })
      if (this.user.isSuperadmin() || this.user.isMasterAdministrator()) {
        listArr.push({
          key: 'delete',
          name: 'Delete',
          danger: true
        })
      }

      return listArr
    }
  },
  methods: {
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    },
    redirectToEdit () {
      this.$router.push({ name: 'ebs-report-builder-edit', params: { id: this.reportId } })
    },
    redirectToSchedule () {
      this.$router.push({ name: 'ebs-report-builder-schedule-edit', params: { id: this.reportId } })
    },
    redirectToReportExecute () {
      this.$router.push({ name: 'ebs-report-builder-execute', params: { id: this.reportId } })
    },
    performRemoveReport () {
      this.$store.dispatch('ebsReportBuilderRemove', this.reportId).then(() => {
        this.$eventBus.$emit('start-loading')
        this.$store.dispatch('ebsReportsGetDefinedReports').finally(() => {
          this.$eventBus.$emit('stop-loading')
        })
      })
    },
    performGenerateCSV () {
      this.csvRequestPending = true
      this.$store.dispatch('ebsReportBuilderGenerateDefinedReportCSV', { id: this.reportId, name: this.reportName }).finally(() => {
        this.csvRequestPending = false
      })
    }
  }
}
</script>
